import { GradesConfig } from '../parts/EvaluationForm/types';

export interface AcademicLevels {
  id: number;
  name: string;
  structureTypeId: number;
  structureType: StructureType;
}

export interface GradesStructure {
  id: number;
  academicLevelId: number;
  deliveryMode: string;
  structureTypeId: number;
  structureType: StructureType;
  updatedAt?: string;
}

export interface StructureType {
  id: number;
  name: string;
  code: string;
  description: string;
  color: string;
}

export interface ModalitiesTypes {
  name: string;
  code: string;
}

// Table
export interface AcademicLevelsResponse {
  data: {
    id: number;
    code: string;
    name: string;
    updatedAt: string;
    gradesStructures: GradesStructure[];
  }[];
}

// Form selects
export interface AcademicLevelsFormDataResponse {
  academicLevels: AcademicLevels[];
  structureType: StructureType[];
  modalitiesTypes: ModalitiesTypes[];
}

// Form Data
export interface FormDataAction {
  structureTypeId: {
    value: number;
    label: string;
  };
  finalGrade?: null | GradesConfig['finalGrade'];
  testGrades?: null | GradesConfig['testGrades'];
  deliveryMode?: string;
  academicLevelId?: number;
}

export type FormDataContext = Pick<FormDataAction, 'finalGrade' | 'testGrades'>;

export interface StructureTypeSchema {
  finalEvaluationsConfig: null | GradesConfig['finalGrade'];
  partialEvaluationsConfig: null | GradesConfig['testGrades'];
}
export interface GradingStructureInfoResponse {
  academicLevel: {
    id: number;
    name: string;
    code: string;
  };
  modalityDeliveryMode: {
    name: string;
    code: string;
  };
  gradesStructure: {
    id: number;
    structureType: StructureType;
    currentStructureTypeSchema: StructureTypeSchema;
  };
}

export enum StructureTypeCode {
  FREE = 1,
  FIXED,
  SEMIFIXED,
}
